import first from 'lodash/first';

export default function (list) {
    let lastBallot = first(list) || null;

    return lastBallot;
}
